import { ClockIcon } from "@app/design-system/icons";
import styles from "./EtaMarkerOverlay.module.css";

export type EtaMarkerOverlayProps = {
  label: string;
};

/**
 * The floating ETA pill rendered above a marker (which marker, and whether
 * to show one at all, is decided by `hooks/useMarkerEta.ts` — this
 * component only knows how to render a label). Purely presentational and
 * provider-agnostic; each adapter positions it at the target marker's
 * coordinates with an upward offset.
 */
export const EtaMarkerOverlay = ({ label }: EtaMarkerOverlayProps) => (
  <span className={styles.pill}>
    <ClockIcon size={14} className={styles.icon} />
    {label}
  </span>
);
